<template>
  <Navbar />
  <router-view v-slot="slotProps">
    <transition name="fade" mode="out-in">
      <div>
      <component :is="slotProps.Component"></component>
      </div>
    </transition>
  </router-view>
</template>

<script>
import router from "../router";
import Navbar from "./Navbar";
export default {
  components: {
    Navbar,
  },
  name: "mainView",
  data() {
    return {
      gameOver: null,
      hoursLeft: null,
      account: null,
      currentRoute: null,
      expiredDate: null,
      winningToken: 0,
    };
  },
  mounted() {
    if (!localStorage.getItem("wax_user")) {
      router.push("/login");
    }
  },
  methods: {
    logout: function () {
      router.push("/login");
    },
  },
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.75s ease-out;
}

.slide-enter-to {
  position: absolute;
  right: 0;
}

.slide-enter-from {
  position: absolute;
  right: -100%;
}

.slide-leave-to {
  position: absolute;
  left: -100%;
}

.slide-leave-from {
  position: absolute;
  left: 0;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.3s ease-out;
}

.fade-leave-active {
  transition: opacity 0.3s ease-out;
}
</style>